const modal = {
    size: [
        'small',
        'medium',
        'large',
        'xLarge'
    ],

    align: [
        'top-center', 
        'top-left',
        'center-center', 
        'center-left', 
    ]
};

export default modal;